import axios from "axios";

export async function getTranslation(textToTranslate: string) {
    let err = null;
    let res: any = null;
    let translatedText: string = "";
    var sourceLang = 'en';
    var targetLang = 'ar';
    textToTranslate = textToTranslate.replaceAll("&amp;", "&");
    var url = "https://translate.googleapis.com/translate_a/single?client=gtx&sl=" + sourceLang + "&tl=" + targetLang + "&dt=t&q=" + encodeURIComponent(textToTranslate);
    try {
        ({ data: res } = await axios.get(
            url,
            {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
        ));

        if (res && res.length > 0 && res[0].length > 0) {
            for (var i = 0; i < res[0].length; i++) {
                if (res[0][i] && res[0][i].length > 0) {
                    translatedText += res[0][i][0];
                }
            }
        }

    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, translatedText];
}